import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { logoutAction } from '../../store/actions/general';
import { RootState } from '../../store/types/sharedTypes';
import { stringAvatar } from '../../lib/helpers/avatar';
import { GENERAL_FONT } from '../../constants/theme';
import BuildInfo from '../BuildInfo';

import type { AppDispatch } from '../../store';

export interface SimpleDialogProps {
  open: boolean;
  onClose: (value?: string) => void;
}

const UserDialog = (props: SimpleDialogProps) => {
  const { onClose, open } = props;
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  const { sessionUser } = useSelector((state: RootState) => state.general);

  const { t } = useTranslation();
  const menuItems = [t('myProfile').toString(), t('logout') as string];

  const handleClose = () => {
    onClose('Close');
  };

  const handleListItemClick = (value: string) => {
    if (
      value.toLocaleLowerCase() === 'logout' ||
      value.toLocaleLowerCase() === 'logga ut'
    ) {
      dispatch(logoutAction(navigate));
    }
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle style={{ fontFamily: GENERAL_FONT }}>
        {' '}
        {t('userOptions')}{' '}
      </DialogTitle>

      <List sx={{ pt: 0, fontFamily: GENERAL_FONT }}>
        {menuItems.map((item) => (
          <ListItem disableGutters key={item}>
            <ListItemButton onClick={() => handleListItemClick(item)}>
              {item === t('myProfile') && (
                <ListItemAvatar>
                  <Avatar
                    style={{ marginLeft: '10px', fontFamily: GENERAL_FONT }}
                    {...stringAvatar(
                      `${sessionUser?.firstName} ${sessionUser?.lastName}`
                    )}
                  />
                </ListItemAvatar>
              )}
              <ListItemText
                style={{
                  textAlign: 'center',
                  fontFamily: `${GENERAL_FONT} !important`,
                }}
                primary={item}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Box sx={{ display: 'flex', justifyContent: 'center', pb: 1.25 }}>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontFamily: GENERAL_FONT,
            letterSpacing: 0.3,
          }}
        >
          <BuildInfo />
        </Typography>
      </Box>
    </Dialog>
  );
};

export default UserDialog;
